<template>
  <form
    class="TNovoUsuario"
    data-testid="TNovoUsuario"
  >
    <div class="TNovoUsuario__Header">
      <slot name="navegacao" />
    </div>
    <div class="TNovoUsuario__Perfil">
      <slot name="perfil" />
    </div>
    <div class="TNovoUsuario__TabMenu">
      <slot name="tabmenu" />
    </div>
    <div class="TNovoUsuario__Centro">
      <slot name="centro" />
    </div>
    <div class="TNovoUsuario__Rodape">
      <slot name="rodape" />
    </div>
  </form>
  <slot name="modais" />
</template>

<style lang="scss">
  @import "./TNovoUsuario.style.scss";
</style>
